<template>
	<section class="assessment-characteristics">
		<h2 :class="headingClasses">
			<span class="assessment-characteristics__icon">
				<slot name="icon"><!-- font awesome icon --></slot>
			</span>
			<slot name="heading"><!-- heading text --></slot>
		</h2>
		<div v-if="showAsList">
			<ul v-if="showSkeleton" class="assessment-characteristics__attributes assessment-characteristics__attributes--skeleton">
				<li><Skeleton animation="none" /></li>
				<li><Skeleton animation="none" /></li>
				<li><Skeleton animation="none" /></li>
			</ul>
			<ul v-else class="assessment-characteristics__attributes assessment-characteristics__attributes--default">
				<li v-for="characteristic in characteristics" :key="characteristic">
					<div>&bull;</div>
					<div>{{ characteristic }}</div>
				</li>
			</ul>
		</div>
		<div v-else>
			<p v-if="showSkeleton"><Skeleton animation="none" /></p>
			<p v-else>{{ characteristics }}</p>
		</div>
	</section>
</template>

<script>
import Skeleton from "primevue/skeleton";

export default {
	name: "AssessmentCharacteristics",
	components: {
		Skeleton,
	},
	props: {
		isSkeleton: {
			type: Boolean,
			default: true,
		},
		autoSkeleton: {
			type: Boolean,
			default: true,
		},
		highType: {
			type: String,
			default: "X",
			validator( value ) {
				return [ "D", "I", "S", "C", "X", ].includes( value );
			},
		},
		characteristics: {
			type: [ Array, String, ],
			default: () => [],
		},
	},
	computed: {
		headingClasses() {
			const { highType, } = this;

			return {
				"assessment-characteristics__heading": true,
				[ `discTextLabel__${ highType }-hightype-label` ]: true,
				[ `discTextLabel__${ highType }-duotone-icon` ]: true,
			};
		},
		showSkeleton() {
			const { isSkeleton, autoSkeleton, characteristics, } = this;
			return isSkeleton || ( autoSkeleton && !characteristics.length );
		},
		showAsList() {
			return Array.isArray( this.characteristics );
		},
	},
};
</script>

<style lang="scss" scoped>
.assessment-characteristics {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	p {
		@include font-and-line-for(0);
		text-align: left;
	}
}

.assessment-characteristics__heading {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: flex-start;
	gap: 0.5rem;

	@include font-and-line-for(1);
	text-align: left;
	margin-top: 1.25rem;

	&:first-of-type {
		margin-top: 0;
	}
}

.assessment-characteristics__attributes {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	margin: 0;
	// center under the icon
	margin-left: 1.3rem;

	li {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: flex-start;
		gap: 0.4rem;

		@include font-and-line-for(0);
		text-align: left;

		:first-child {
			font-weight: bold;
			margin-top: -0.1rem;
		}
	}
}

.assessment-characteristics__attributes--skeleton {
	li::before {
		color: $assessment-characteristics-skeleton-bullet-color; /* Change the bullet color */
	}
}

.assessment-characteristics__attributes--default {
	li::before {
		color: $assessment-characteristics-bullet-color; /* Change the bullet color */
	}
}
</style>
